import React, { useEffect, useRef, Suspense } from 'react';
import Lenis from '@studio-freight/lenis';
import { Link } from 'react-router-dom';
import TextAnimation from './animations/TextAnimation';




const FrontPage = () => {
  const mainCopyTextWrapRef = useRef(null);
  const mainCopyTextRef = useRef(null);
  const copyImg1 = useRef(null);
  const copyImg2 = useRef(null);
  const copyImg3 = useRef(null);
  const copyImg4 = useRef(null);
  const copyImg5 = useRef(null);
  const contactRef = useRef(null);
  const stokerRef = useRef(null);
  const handImgRef = useRef(null);
  const circleRef = useRef(null);
  const textRefs = useRef([]);


  const mousePosition = useRef({ x: 0, y: 0 });
  const stokerPosition = useRef({ x: 0, y: 0 });



  /* scrollAnimation JS  ----------------------------------------*/


  useEffect(() => {

    const text = textRefs.current;

    if (text.length === 0) {
      console.error('No elements found in textRefs');
      return;
    }

    text.forEach((t, i) => {
      setTimeout(() => {
        t.classList.remove('textAnimationA');
      }, i * 200);
    });

   

    const easeInOutCubic = (x) => {
      return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    };

    const updateTriggerTop = () => {
      if (!mainCopyTextWrapRef.current) return 0;
          return mainCopyTextWrapRef.current.getBoundingClientRect().top + window.scrollY - 200;
    };

    let triggerTop = updateTriggerTop();

    const handleResize = () => {
      triggerTop = updateTriggerTop();
    };

    window.addEventListener('resize', handleResize);

    const handleScroll = (scrollPos) => {
      const scrollPosition = scrollPos - triggerTop;
      const mainCopyTextWrap = mainCopyTextWrapRef.current;
      const mainCopyText = mainCopyTextRef.current;

      if (!mainCopyTextWrap || !mainCopyText) return;

      if (scrollPosition > 0) {
        const scrollPercent = easeInOutCubic(scrollPosition / (mainCopyTextWrap.offsetHeight - 200));
        const textWidth = mainCopyText.offsetWidth;
        const tagPosition = Math.min((textWidth + 480) * scrollPercent, textWidth);
        mainCopyText.style.transform = `translateX(${-tagPosition}px)`;
      }


      const copyImages = [copyImg1, copyImg2, copyImg3, copyImg4, copyImg5];
      const thresholds = [100, 300, 500, 1200, 800];

      copyImages.forEach((img, index) => {
        if (scrollPosition > thresholds[index]) {
          img.current.classList.add('activeClass');
        } else if (scrollPosition < 0) {
          img.current.classList.remove('activeClass');
        }
      });

    };

    const lenis = new Lenis({ lerp: 0.2, duration: 1 });
    lenis.on('scroll', ({ scroll }) => {
      handleScroll(scroll); // 既存のハンドラ
      const event = new CustomEvent('lenis-scroll', {
        detail: { scroll }, // スクロール値を含める
      });
      window.dispatchEvent(event); // カスタムイベントを発火
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);



    return () => {
      window.removeEventListener('resize', handleResize);
      lenis.off('scroll', handleScroll);
      lenis.destroy();
    };
  }, []);

  /* mouseAnimation JS  ----------------------------------------*/
  useEffect(() => {
    const contact = contactRef.current;
    const stoker = stokerRef.current;
    const handImg = handImgRef.current;
    const circle = circleRef.current;

    if (!contact || !stoker || !handImg || !circle) return;

    const handleMouseMove = (event) => {
      const rect = contact.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      // マウスのターゲット位置を更新
      mousePosition.current = { x, y };
    };

    const handleMouseEnter = () => {
      stoker.style.opacity = '1'; // 表示
    };

    const handleMouseLeave = () => {
      stoker.style.opacity = '0'; // 非表示
    };

    const handleCircleEnter = () => {
      // 最新の handImg の位置を取得
      const handImgRect = handImg.getBoundingClientRect();
      const contactRect = contact.getBoundingClientRect();

      const handImgX = handImgRect.left - contactRect.left; // contact 内での相対位置
      const handImgY = handImgRect.top - contactRect.top; // contact 内での相対位置

      // handImg の位置に stoker を移動
      stokerPosition.current.x = handImgX;
      stokerPosition.current.y = handImgY;

      // 即座に位置を更新
      stoker.style.left = `${stokerPosition.current.x}px`;
      stoker.style.top = `${stokerPosition.current.y}px`;

      // .stokerRef を縮小
      stoker.style.transform = 'scale(0)';

      // handImg の画像を変更
      handImg.src = 'images/hand2.png';
    };

    const handleCircleLeave = () => {
      // .stokerRef を元に戻す
      stoker.style.transform = 'scale(1)';
      // handImg の画像を元に戻す
      handImg.src = 'images/hand1.png';
    };

    const updateStokerPosition = () => {
      const targetX = mousePosition.current.x;
      const targetY = mousePosition.current.y;

      // イージングを使ってストーカーの位置を更新
      stokerPosition.current.x += (targetX - stokerPosition.current.x) * 0.1;
      stokerPosition.current.y += (targetY - stokerPosition.current.y) * 0.1;

      stoker.style.left = `${stokerPosition.current.x }px`;
      stoker.style.top = `${stokerPosition.current.y }px`;

      // 次のフレームをリクエスト
      requestAnimationFrame(updateStokerPosition);
    };

    // イージングの更新を開始
    updateStokerPosition();

    // イベントリスナーを追加
    contact.addEventListener('mousemove', handleMouseMove);
    contact.addEventListener('mouseenter', handleMouseEnter);
    contact.addEventListener('mouseleave', handleMouseLeave);
    circle.addEventListener('mouseenter', handleCircleEnter);
    circle.addEventListener('mouseleave', handleCircleLeave);

    return () => {
      contact.removeEventListener('mousemove', handleMouseMove);
      contact.removeEventListener('mouseenter', handleMouseEnter);
      contact.removeEventListener('mouseleave', handleMouseLeave);
      circle.removeEventListener('mouseenter', handleCircleEnter);
      circle.removeEventListener('mouseleave', handleCircleLeave);
    };
  }, []);


  return (
    <>
      <TextAnimation clssName={'.textAnimationWrap'} distance={'25px'} easeTime={'30'} />

      

      <div className="aboutwrapper">
        <h1 className="saite_title">
          {['Art Director', 'UI/UX Designer', 'Engineer', 'Photographer', 'Video Editor'].map((text, index) => (
            <div key={index}>
              <span
       
                className="front-text textAnimationA"
                ref={(el) => {
                  if (el && !textRefs.current.includes(el)) {
                    textRefs.current.push(el); // 重複を防ぐためにチェックして登録
                  }
                }}
              >
                {text}
              </span>
            </div>
          ))}
        </h1>
      </div>

      <div id="mainTitle" className="textAnimationWrap">
        <Link to="/">
          <h2>TAKUYA KIMIZUKA</h2>
        </Link>
      </div>

      <div id="linkWrap" className={"spNone"}>
        <ul>
          <li className="textAnimationWrap">
            <a href="https://www.instagram.com/tky___09/" target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          </li>

          <li className="textAnimationWrap">
            <a href="mailto:takuya.kimizuka@gmail.com?subject=お問い合わせ">Mail</a>
          </li>
        </ul>
      </div>

      <div className="profileText">
        <p>
          アパレル業界での経験を活かしWebデザイナーに転身。<br  className="pcNone"/>
          2018年に株式会社RIDEに入社し、<br className="pcNone" />
          Webデザイナーとしてリブランディング、<br className="pcNone" />
          Web制作、撮影など多岐にわたるプロジェクトに従事。
        </p>
      </div>

      <div className="mainCopyTextWrap" ref={mainCopyTextWrapRef}>

       

        <h2>
          <p className="mainCopyText" ref={mainCopyTextRef}>
            “Creating value through seamless design expertise”

            <img src="/images/copyImg_2.png" className={"copyImg img1"} ref={copyImg1} />
            <img src="/images/copyImg_3.png" className={"copyImg img2"} ref={copyImg2} />
            <img src="/images/copyImg_4.png" className={"copyImg img3"} ref={copyImg3} />
            <img src="/images/copyImg_1.png" className={"copyImg img4"} ref={copyImg4} />
            <img src="/images/copyImg_5.png" className={"copyImg img5"} ref={copyImg5} />
          </p>
        </h2>
      </div>

      <div className={"serviceArea"}>

        <h3>
          デジタルデザイン全般に携わり、企画から完成まで一貫して手掛けるスキルを保有。リブランディングでは、ブランドの本質を捉えた戦略的なデザインを提案します。ロゴ制作では、ブランドの魅力を最大限に引き出す成果を追求。トレンドを意識した最新の3D制作を活用し、視覚的なインパクトを重視したデザインを実現します。さらに、バナー制作や動画制作にも対応し、多様なメディアでブランド価値を高める表現を提供します。
        </h3>

        <ul className={"skillListWrap"}>
          <li className={"skillList"}>
            <h4 className={"skillCategory"}>Branding</h4>
            <ul className={"skillNameWrap"}>
              <li className={"skillName"} >アートディレクション</li>
              <li className={"skillName"}>ロゴ制作</li>
            </ul>
          </li>

          <li className={"skillList"}>
            <h4 className={"skillCategory"}>DigitalDesign</h4>
            <ul className={"skillNameWrap"}>
              <li className={"skillName"} >WEBディレクション</li>
              <li className={"skillName"}>UX/UI デザイン</li>
              <li className={"skillName"} >フロントエンドコーディング</li>
              <li className={"skillName"}>3D制作</li>
              <li className={"skillName"} >動画制作</li>
              <li className={"skillName"}>Wordpress構築</li>
            </ul>
          </li>

          <li className={"skillList"}>
            <h4 className={"skillCategory"}>Photographic</h4>
            <ul className={"skillNameWrap"}>
              <li className={"skillName"} >撮影ディレクション</li>
              <li className={"skillName"}>撮影</li>
              <li className={"skillName"} >レタッチ</li>

            </ul>
          </li>

          <li className={"skillList"}>
            <h4 className={"skillCategory"}>Skill List</h4>

            <ul className={"skillNameWrap Tours"}>
              <li className={"skillName"} >Adobe Photoshop</li>
              <li className={"skillName"}>Adobe Illustrator</li>
              <li className={"skillName"} >Adobe Indesign</li>
              <li className={"skillName"} >Adobe XD</li>
              <li className={"skillName"}>Adobe Aftereffect</li>
              <li className={"skillName"} >Adobe PremiumPro</li>
              <li className={"skillName"} >Adobe Lightroom</li>
              <li className={"skillName"}>Blender</li>
              <li className={"skillName"} >Html</li>
              <li className={"skillName"} >css </li>
              <li className={"skillName"}>Sass</li>
              <li className={"skillName"} >Java Script</li>
              <li className={"skillName"} >React</li>
              <li className={"skillName"}>Three.js</li>
              <li className={"skillName"} >Wordpress</li>
              <li className={"skillName"} >jQuery</li>


            </ul>
          </li>

        </ul>

        <div className={"contact"} ref={contactRef}>
          <div className={"circle"} ref={circleRef}>
            <a href="mailto:takuya.kimizuka@gmail.com?subject=お問い合わせ" className="contactLink">
              <img src="images/circle.svg" />
            </a>
          </div>
          <p>
            
               Add Projects
              <span>
                <img src="images/hand1.png" className="handImg spNone" ref={handImgRef} />

                <img src="images/hand2.png" className="handImg pcNone" />
              </span>
            

            <img src="images/hand1.png" className="handImgStoker" ref={stokerRef} />
       
          </p>
        </div>

      </div>

      <footer>
        <div className={"profileTextWrap"}>

          <div className={"textAnimationWrap logoText"}>
            <Link to="/">
              ( TKY™︎  — 09 )
            </Link>
          </div>

          <div className={"textAnimationWrap  mainName"}>
            <Link to="/">
              <h2>TAKUYA KIMIZUKA</h2>
            </Link>
          </div>

          <div className="linkWrap">
            <ul>
              <li className="textAnimationWrap">
                <a href="https://www.instagram.com/tky___09/" target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              </li>

              <li className="textAnimationWrap">
                <a href="mailto:takuya.kimizuka@gmail.com?subject=お問い合わせ">Mail</a>
              </li>
            </ul>
          </div>

        </div>



        <p className={"copylight"}>©︎TAKUYA KIMIZUKA</p>

        
      </footer>

      <Suspense fallback={null}>
         
      </Suspense>

    
    </>
  );
};

export default FrontPage;
